var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.svgIcon,{tag:"component",staticClass:"inline-block fill-current focus:outline-none",style:(_vm.iconStyles),attrs:{"aria-label":_vm.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }